const sids = [
  'jig',
  'talentpool',
  'edunet',
  'wconat',
  'ncph',
  't4a',
  'edunetke',
  'edunetasia',
  'edunetma',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'ragtp',
  'kle',
  'bbg',
  'wrktp',
  'amseu',
  'coe',
];
const sidCurses = [
  'jobtalent',
  'jnjts',
  'ragtp',
  'kle',
  'bbg',
  'wrktp',
  'coe',
];
const sidsIndividualBanner = [
  'edunetke',
  'edunetasia',
  'edunetma',
  'edunetin',
  'kle',
  'bbg',
  'coe',
];

const sidsProfessionQueryTsp = [
  'jnjts',
];

const sidsNewProfileConsultant = [
  'wrktp',
  'jnjts',
];

const sidsEnabledChat = [
  'wrktp',
  'jnjts',
  'coe',
  'kle',
  'bbg',
];

const sidsIframeCabinetConsultant = [
  'coe',
  'jnjts',
];

const sidsCompanyQuery = [
  'kle',
  'bbg',
  'coe',
];
const sidsFontTemplate = [
  'talentpool',
  'edunet',
  'edunetke',
  'edunetasia',
  'edunetma',
  'wconat',
  'ncph',
  't4a',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'kle',
  'bbg',
  'wrktp',
  'amseu',
  'coe',
];
const sidsNewCabinet = [
  'aba',
  'abatest',
  'talentpool',
  'jig',
  'edunet',
  'edunetke',
  'edunetasia',
  'edunetma',
  'wconat',
  'ncph',
  't4a',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'wrktp',
  'amseu',
  'coe',
  'kle',
  'bbg',
];

const sidsLocationCountryFilter = [
  'jnjts',
  'wrktp',
];

export const group = (sid: string) => sids.includes(sid);
export const individualBannerGroup = (sid: string) => sidsIndividualBanner.includes(sid);
export const groupCurses = (sid: string) => sidCurses.includes(sid);
export const groupProfessionQueryTsp = (sid: string) => sidsProfessionQueryTsp.includes(sid);
export const groupNewProfileConsultant = (sid: string) => sidsNewProfileConsultant.includes(sid);
export const groupEnabledChat = (sid: string) => sidsEnabledChat.includes(sid);
export const groupIframeCabinetConsultant = (sid: string) => sidsIframeCabinetConsultant.includes(sid);
export const groupCompanyQuery = (sid: string) => sidsCompanyQuery.includes(sid);
export const groupFontTemplate = (sid: string) => sidsFontTemplate.includes(sid);
export const groupNewCabinet = (sid: string) => sidsNewCabinet.includes(sid);
export const groupLocationCountryFilter = (sid: string) => sidsLocationCountryFilter.includes(sid);
